import { useTranslation } from 'react-i18next'
import { Chip } from '@material-tailwind/react'
import PropTypes from 'prop-types'

/*
 * @param {string} value
 * @param {object} options
 * @returns {JSX.Element}
 * @constructor
 * @example
 * <StatusChip value='active' options={{ active: 'green', inactive: 'red' }} />
 * <StatusChip value='inactive' options={{ active: 'green', inactive: 'red' }} />
 * available color options: #https://www.material-tailwind.com/docs/react/chip#chip-colors
 * */
export const StatusChip = ({ value, options }) => {
  const { t } = useTranslation()

  const chipColor = options[value] || 'black'
  return (
    <Chip
      variant='ghost'
      color={chipColor}
      size='sm'
      className='capitalize text-center w-fit h-fit'
      value={t(`${value}.one`)}
    />
  )
}

StatusChip.propTypes = {
  value: PropTypes.oneOf(['active', 'inactive']).isRequired,
  options: PropTypes.object
}
